/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cuddly_Antsy_Jaguar_GulpInputs */

const fr_cuddly_antsy_jaguar_gulp = /** @type {(inputs: Cuddly_Antsy_Jaguar_GulpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Défini ton mot de passe pour utiliser l'application.`)
};

/**

* @param {Cuddly_Antsy_Jaguar_GulpInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const cuddly_antsy_jaguar_gulp = /** @type {((inputs?: Cuddly_Antsy_Jaguar_GulpInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cuddly_Antsy_Jaguar_GulpInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_cuddly_antsy_jaguar_gulp(inputs)
});